import { RestaurantType } from "src/business/restaurant/restaurant";
import {
  getFeatureQuota,
  isUnlimitedQuota,
} from "src/helpers/FeatureCapabilityConfig";

/**
 * How many staff accounts an organization may hold.
 *
 * Staff are organization-wide but the allowance is sold per restaurant, so the
 * pool is the sum of what each subscribed restaurant's tier grants — the same
 * shape as the flat "three per restaurant" it replaces, now read from the
 * capabilities the restaurant actually holds.
 *
 * One restaurant on a tier with `staff_size_unlimited` makes the whole pool
 * unbounded, which falls out of the arithmetic: Infinity survives the sum.
 */
export const staffAllowanceFor = (restaurants: RestaurantType[]): number =>
  restaurants.reduce(
    (total, restaurant) =>
      total +
      getFeatureQuota(
        "staff",
        restaurant.capabilities.map((capability) => capability.name),
      ),
    0,
  );

/**
 * Whether one more invitation would exceed the pool. An unbounded allowance is
 * never at its limit; an empty one always is, which is what an organization
 * with no subscribed restaurant should read as.
 */
export const isStaffPoolFull = (
  staffCount: number,
  allowance: number,
): boolean => !isUnlimitedQuota(allowance) && staffCount >= allowance;
